export enum ESpinnerSize {
    small = 1,
    medium = 2,
    big = 3
}

export const Spinner = ({ size = ESpinnerSize.medium }: { size?: ESpinnerSize }): JSX.Element => {
    return (
        <div id="spinnerId" className="u-text-center u-color-tertiary">
            <i className={`far fa-circle-notch fa-spin fa-${size}x`}></i>
        </div>
    );
};
